// extracted by mini-css-extract-plugin
module.exports = {"taskItem":"taskItem___3teYi","taskInfo":"taskInfo___xD-Z4"};